import { GalleryItem } from "./LoveLineGallery.types";

import THUMB_1 from "./assets/thumbs/1.jpg";
import THUMB_2 from "./assets/thumbs/2.jpg";
import THUMB_3 from "./assets/thumbs/3.jpg";
import THUMB_4 from "./assets/thumbs/4.jpg";
import THUMB_5 from "./assets/thumbs/5.jpg";
import THUMB_6 from "./assets/thumbs/6.jpg";
import THUMB_7 from "./assets/thumbs/7.jpg";
import THUMB_8 from "./assets/thumbs/8.jpg";
import THUMB_9 from "./assets/thumbs/9.jpg";
import THUMB_10 from "./assets/thumbs/10.jpg";
import THUMB_11 from "./assets/thumbs/11.jpg";
import THUMB_12 from "./assets/thumbs/12.jpg";
import THUMB_13 from "./assets/thumbs/13.jpg";
import THUMB_14 from "./assets/thumbs/14.jpg";
import THUMB_15 from "./assets/thumbs/15.jpg";
import THUMB_16 from "./assets/thumbs/16.jpg";
import THUMB_17 from "./assets/thumbs/17.jpg";
import THUMB_18 from "./assets/thumbs/18.jpg";
import THUMB_19 from "./assets/thumbs/19.jpg";
import THUMB_20 from "./assets/thumbs/20.jpg";
import THUMB_21 from "./assets/thumbs/21.jpg";
import THUMB_22 from "./assets/thumbs/22.jpg";

import IMAGE_1 from "./assets/images/1.jpeg";
import IMAGE_2 from "./assets/images/2.jpeg";
import IMAGE_3 from "./assets/images/3.jpeg";
import IMAGE_4 from "./assets/images/4.jpeg";
import IMAGE_5 from "./assets/images/5.jpeg";
import IMAGE_6 from "./assets/images/6.jpeg";
import IMAGE_7 from "./assets/images/7.jpeg";
import IMAGE_8 from "./assets/images/8.jpeg";
import IMAGE_9 from "./assets/images/9.jpeg";
import IMAGE_10 from "./assets/images/10.jpeg";
import IMAGE_11 from "./assets/images/11.jpg";
import IMAGE_12 from "./assets/images/12.jpg";
import IMAGE_13 from "./assets/images/13.jpg";
import IMAGE_14 from "./assets/images/14.jpg";
import IMAGE_15 from "./assets/images/15.jpg";
import IMAGE_16 from "./assets/images/16.jpg";
import IMAGE_17 from "./assets/images/17.jpg";
import IMAGE_18 from "./assets/images/18.jpg";
import IMAGE_19 from "./assets/images/19.jpg";
import IMAGE_20 from "./assets/images/20.jpg";
import IMAGE_21 from "./assets/images/21.jpg";
import IMAGE_22 from "./assets/images/22.jpg";

export const GALLERY: GalleryItem[] = [
  {
    thumb: THUMB_1,
    image: IMAGE_1,
  },
  {
    thumb: THUMB_2,
    image: IMAGE_2,
  },
  {
    thumb: THUMB_3,
    image: IMAGE_3,
  },
  {
    thumb: THUMB_4,
    image: IMAGE_4,
  },
  {
    thumb: THUMB_5,
    image: IMAGE_5,
  },
  {
    thumb: THUMB_6,
    image: IMAGE_6,
  },
  {
    thumb: THUMB_7,
    image: IMAGE_7,
  },
  {
    thumb: THUMB_8,
    image: IMAGE_8,
  },
  {
    thumb: THUMB_9,
    image: IMAGE_9,
  },
  {
    thumb: THUMB_10,
    image: IMAGE_10,
  },

  {
    thumb: THUMB_11,
    image: IMAGE_11,
  },
  {
    thumb: THUMB_12,
    image: IMAGE_12,
  },
  {
    thumb: THUMB_13,
    image: IMAGE_13,
  },
  {
    thumb: THUMB_14,
    image: IMAGE_14,
  },
  {
    thumb: THUMB_15,
    image: IMAGE_15,
  },
  {
    thumb: THUMB_16,
    image: IMAGE_16,
  },
  {
    thumb: THUMB_17,
    image: IMAGE_17,
  },
  {
    thumb: THUMB_18,
    image: IMAGE_18,
  },
  {
    thumb: THUMB_19,
    image: IMAGE_19,
  },
  {
    thumb: THUMB_20,
    image: IMAGE_20,
  },
  {
    thumb: THUMB_21,
    image: IMAGE_21,
  },
  {
    thumb: THUMB_22,
    image: IMAGE_22,
  },
];
